import React, { ReactNode } from 'react';

export default function Box(props: {
    title: string;
    content: string;
    step: number;
    icon: ReactNode;
}) {
    return (
        <div className={'mt-5 w-[400px] rounded border-2 border-SM-yellow'}>
            <div className={'mr-[10%] flex -translate-y-8 justify-end'}>
                <div className={'absolute text-6xl font-black font-bold text-SM-yellow/80'}>
                    0{props.step}
                </div>
            </div>
            <div className={'p-6'}>
                <div className={'mb-2 text-4xl font-bold text-SM-yellow'}>{props.icon}</div>
                <h2 className={'mb-2 font-medium'}>{props.title}</h2>
                <p>{props.content}</p>
            </div>
        </div>
    );
}
